import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: [],
})
export class AuthLayoutComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
